// extracted by mini-css-extract-plugin
export var standaloneTable = "_du-0";
export var standaloneTableWithBodyFill = "_du-1";
export var withExtraHeader = "_du-2";